import Helmet from "react-helmet";

function Morph() {

	return (
		<div>
			<Helmet>
				<script>
				{
				`var elts = {
					text1: document.getElementById("text1"),
					text2: document.getElementById("text2")
				};

				// The strings to morph between. You can change these to anything you want!
				var texts = [
					"ഭരതം",
					"ഭാവം",
					"രാഗം",
					"താളം"
				];

				// Controls the speed of morphing.
				var morphTime = 1.25;
				var cooldownTime = 1.5;

				var textIndex = texts.length - 1;
				var time = new Date();
				var morph = 0;
				var cooldown = cooldownTime;

				elts.text1.textContent = texts[textIndex % texts.length];
				elts.text2.textContent = texts[(textIndex + 1) % texts.length];

				function doMorph() {
					morph -= cooldown;
					cooldown = 0;
					
					var fraction = morph / morphTime;
					
					if (fraction > 1) {
						cooldown = cooldownTime;
						fraction = 1;
					}
					
					setMorph(fraction);
				}

				// A lot of the magic happens here, this is what applies the blur filter to the text.
				function setMorph(fraction) {
					// fraction = Math.cos(fraction * Math.PI) / -2 + .5;
					
					elts.text2.style.filter = \`blur(\${Math.min(8 / fraction - 8, 100)}px)\`;
					elts.text2.style.opacity = \`\${Math.pow(fraction, 0.4) * 100}%\`;
					
					fraction = 1 - fraction;
					elts.text1.style.filter = \`blur(\${Math.min(8 / fraction - 8, 100)}px)\`;
					elts.text1.style.opacity = \`\${Math.pow(fraction, 0.4) * 100}%\`;
					
					elts.text1.textContent = texts[textIndex % texts.length];
					elts.text2.textContent = texts[(textIndex + 1) % texts.length];
				}

				function doCooldown() {
					morph = 0;
					
					elts.text2.style.filter = "";
					elts.text2.style.opacity = "100%";
					
					elts.text1.style.filter = "";
					elts.text1.style.opacity = "0%";
				}

				// Animation loop, which is called every frame.
				function animate() {
					requestAnimationFrame(animate);
					
					var newTime = new Date();
					var shouldIncrementIndex = cooldown > 0;
					var dt = (newTime - time) / 1000;
					time = newTime;
					
					cooldown -= dt;
					
					if (cooldown <= 0) {
						if (shouldIncrementIndex) {
							textIndex++;
						}
						
						doMorph();
					} else {
						doCooldown();
					}
				}

				// Start the animation.
				animate();`
				}

				</script>
			</Helmet>

			<div id="container" className="text-slate-100 relative">
				<span className="text-9xl lg:text-[200px] xl:text-[230px] 2xl:text-[260px]" id="text1"></span>
				<span className="text-9xl lg:text-[200px] xl:text-[230px] 2xl:text-[260px] absolute inset-0" id="text2"></span>
				{/* <div className="text-xl text-center font-light mt-40">-  രാജഗിരി യുവജനോത്സവം  -</div> */}
				{/* <div className="text-lg text-center mt-36">-  May 11, 12, 13 | 2023  -</div> */}
				{/* <div className="text-center font-light mt-4">Rajagiri School of Engineering & Technology</div> */}
			</div>
			
			<svg id="filters">
				<defs>
					<filter id="threshold">
						<feColorMatrix in="SourceGraphic"
								type="matrix"
								values="1 0 0 0 0
										0 1 0 0 0
										0 0 1 0 0
										0 0 0 255 -140" />
					</filter>
				</defs>
			</svg>
		</div>
	);
}

export default Morph;